export const recoverableItemsFolderDescription = "acPEmc";
export default {recoverableItemsFolderDescription};